import React, {useState} from 'react'
import axios from 'axios';
import {morion, motion} from 'framer-motion';

import URL from '../../config/config-server-api'

import './signin.css'
import svgLogin from '../../../img/login/Login.svg'
import Alert from '../../alert/alert'


const SigninForm =(props)=>{

    const [dataUser, setDataUser]  = useState({
        email:'',
        password:''
    })

    const [slertStatus, setAlertStatus] = useState({
        sAlert:''
    })

    const handleChange =(e)=>{
        e.preventDefault()
        // console.log(e.target.value);
        setDataUser({
            ...dataUser,
            [e.target.name]:e.target.value
        })
    }

    const sendData =async(e)=>{
        e.preventDefault()
        if(dataUser.email==="" || dataUser.password ===""){
            setAlertStatus({sAlert:"danger"})
            setTimeout(() => {
                setAlertStatus({sAlert:""})
            }, 3000);
        }
        else{
            // try {
                const url = URL.UrlLogin;
                const config ={
                    headers:{
                        'Content-Type':'application/json'
                    }
                }
                axios.post( url, dataUser, config )
                .then(data=>{
                    console.log(data)
                    console.log('data--')
                    console.log(data.data.userData)
                    console.log(process.env.REACT_APP_ID_OWNER)
                    if(data?.data?.userData._id!=process.env.REACT_APP_ID_OWNER){
                        console.log('Acceso denagado');
                        setAlertStatus({sAlert:"access-denied"})
                        setTimeout(() => {
                            setAlertStatus({sAlert:""})
                        }, 9000);
                        return;
                    }
                    props.userData({newUser:data.data.userData})



                    setAlertStatus({sAlert:"succes"})
                    setDataUser({email:'',password:''})
                    setTimeout(() => {
                        setAlertStatus({sAlert:""})
                    }, 3000);

                        
                })
                .catch(err=>{
                    // console.log(Object.keys(err))
                    // console.log(err?.response)
                    // console.log(err?.response?.data)

                    if(err?.response?.data?.error === "email o password incorrectos"){
                        setAlertStatus({sAlert:"email-password"})
                        setTimeout(() => {
                            setAlertStatus({sAlert:""})
                        }, 3000);
                    }
                    
                })

            // } catch (error) {
            //     console.log(error)
            // }
            

            // setAlertStatus({sAlert:"succes"})
            // setTimeout(() => {
            //     setAlertStatus({sAlert:""})
            // }, 3000);

        }
    } 

    const showAlert =()=>{

        switch (slertStatus.sAlert) {
            case "succes":
                
                return (
                    <Alert tipoAlert="succes" textAlert="BIEN VENIDO"></Alert>
                );
            case "danger":
                return(
                   <Alert tipoAlert="danger" textAlert="Complete los campos requeridos" ></Alert>
                )
            case "email-password":
                return(
                    <Alert tipoAlert="danger" textAlert="email o password incorrecto"></Alert>
                )
            case "access-denied":
                return(
                    <Alert tipoAlert="danger" textAlert="El usuario existe, pero no tiene acceso autorizado.  Para más información comuniquese con el proveedor del servicio"></Alert>
                )
                
            default:
               break

        }
    }

    return (
        <div >
            <div id="aign-up-form" className="fixed top-0 left-0 rigth-0 w-full bg-gray-900 bg-opacity-75  h-screen flex justify-around">

                <div id="form-signin" className="container h-auto my-auto  w-10/12 sm:w-3/5  md:w-2/4 lg:w-2/5  text-center p-4  rounded-lg">
                <div id="container-tbn-signup" className="bg-green-800 relative right-0">
                    <a id="btn-close-signup" className=" right-0 absolute font-bold text-white shadow-2xl" href="#" style={{top:'-14px',right:'-7px'}}>X</a>
                </div>
                            <h1 id="title-singnin" className="py-2 font-bold text-white">INICIAR SESIÓN</h1>
                    <div className="flex justify-center my-3 mb-10">
                                <div className=" rounded-full h-23 w-28 bg-green-500 text-white p-0">
                                    {/* <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"> */}
                                    <img className="rounded-full h-28 w-28" src={svgLogin} alt=""/>
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                                    {/* </svg> */}
                                </div>
                    </div>
                    <form 
                    onSubmit={(e)=>sendData(e)} className="m-1  md:m-10" autocomplete="off" >
                       
                   
                        <div>
                            {/* <label htmlFor=""></label> */}
                            <input 
                                type="email" 
                                name="email" id="" placeholder="Correo electronico *" 
                                className="rounded-full mb-3 w-full py-1 pl-2 border border-transparent focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent"
                                value={dataUser.email}
                                onChange={(e)=>{handleChange(e)}}
                            />
                        </div>
                        <div>
                            <input 
                                type="password" 
                                name="password" id="" placeholder="Contraseña *" 
                                className="rounded-full mb-3 w-full py-1 pl-2 border border-transparent focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent"
                                value={dataUser.password}
                                onChange={(e)=>handleChange(e)}
                            />
                        </div>

                        <div>
                            <button 
                               
                                className=" focus:outline-none border  hover:border-2 border-white-400 hover:bg-green-700 cursor-pointer bg-green-600 text-white font-semibold rounded-full my-6 w-full py-2 pl-2"
                            >
                            Ingresar
                            </button>
                        </div>
                        
                        {showAlert()}

                        <div className="pb-8">
                            {/* <motion.div
                             animate={{scale:[1,0.8,1,0.9,1]}}
                             transition={{duration: 2, ease:"easeInOut",times:[0,0.2,0.5,0.8,1], loop:Infinity, repeatDelay:1}}
                             onClick={()=>props.switchAcces(false)}
                             className="text-blue-100 hover:text-blue-200 cursor-pointer underline">
                                ¿Todabia no tengo cuenta?
                            </motion.div> */}
                        </div>
                        
                    </form>
                </div>
            </div>
        </div>
    );

}


export default SigninForm;